class NfeDownloads {
    get tooltipLimites() {
        textoLimites = []

        if (this.pdf)
            textoLimites.push(`Limite PDF: ${ this.limites.pdf } <br/>`)

        if (this.zipXml)
            textoLimites.push(`Limite ZIP de XMLs: ${ this.limites.zipXml } <br/>`)

        if (this.zipDa)
            textoLimites.push(`Limite ZIP de DAs: ${ this.limites.zipDa } <br/>`)

        if (textoLimites.length)
            textoLimites.push('<br/>', 'Caso o número de resultados seja maior que o limite, o download será dividido em partes.')

        return textoLimites.join('')
    }
}

angular.module('eficienciaFiscalModule')
    .component('nfeDownloads', {
        controller: NfeDownloads,
        bindings: {
            promise: '<',
            nfesSelecionadas: '<',
            xlsx: '&?',
            pdf: '&?',
            zipXml: '&?',
            zipDa: '&?',
            limites: '<'
        },
        template: `
        <div style="margin: 0 0 9px;">
            <promise-tracker promise="$ctrl.promise" active="isDownloading">
                <div style="display: flex; align-items: center; justify-content: flex-end;">
                    <span ng-show="$ctrl.nfesSelecionadas">
                        Realizar o download das NF-e selecionadas ({{ $ctrl.nfesSelecionadas }}) como:
                    </span>

                    <span ng-hide="$ctrl.nfesSelecionadas">
                        Realizar o download dos resultados da consulta como: 
                    </span>

                    <i ng-if="$ctrl.tooltipLimites" tooltip-html-unsafe="{{ $ctrl.tooltipLimites }}" class="fa fa-info-circle" style="margin-left: 5px"></i>

                    <div style="display: flex; text-decoration: underline; color: #3276b1;">
                        <button ng-if="$ctrl.xlsx" ng-click="$ctrl.xlsx()" ng-hide="isDownloading" class="btn btn-xs btn-link">
                            XLSX
                        </button>

                        <button ng-if="$ctrl.pdf" ng-click="$ctrl.pdf()" ng-hide="isDownloading" class="btn btn-xs btn-link">
                            PDF
                        </button>

                        <button ng-if="$ctrl.zipXml" ng-click="$ctrl.zipXml()" ng-hide="isDownloading" class="btn btn-xs btn-link">
                            ZIP dos XMLs
                        </button>

                        <button ng-if="$ctrl.zipDa" ng-click="$ctrl.zipDa()" ng-hide="isDownloading" class="btn btn-xs btn-link">
                            ZIP dos DAs
                        </button>

                        <button ng-show="isDownloading" disabled class="btn btn-xs btn-link">
                            <i class="fa fa-circle-o-notch fa-spin"></i> Baixando...
                        </button>
                    </div>
                </div>
            </promise-tracker>            
        </div>        
        `
    })
